import { useGuestSiteUnlockStateQuery } from './GuestSiteUnlockState.graphql.generated';

// PLAN-17 step-2: canonical unlock-state read, replacing EventWebsiteGuest's activeSession.
// ssr:false — SSR is always anonymous (auth token is client-side only), so the SSR HTML renders
// the locked view and this corrects it post-hydration; firing CSR attaches the token via authLink
// automatically (no auth-upgrade refetch needed). While loading, `hasUnlocked` is undefined —
// gate decisions must treat that as indeterminate (defer gating), not as locked.
// NOTE: joinEvent/logout create a NEW EventSession id, so cache normalization never updates this
// query's result — unlock/logout flows must refetchQueries(['GuestSiteUnlockState']).
export const useGuestSiteUnlockState = (eventHandle: string | undefined) => {
  const { data, loading } = useGuestSiteUnlockStateQuery({
    variables: { eventHandle: eventHandle ?? '' },
    batchMode: 'fast',
    ssr: false,
    skip: !eventHandle,
  });

  return {
    hasUnlocked: data?.eventByName?.activeSession?.hasUnlocked,
    isUnlockStateLoading: loading && !data,
  };
};
